import { every, map, isNull, isNil, trim } from 'lodash';

const challengeTruthy = (foreignAnswer, xpress) =>
{
    if (xpress.substr(0, 1) === '/')
    {
        const regxp = new RegExp(trim(xpress, '/'));
        const match = JSON.stringify(foreignAnswer).match(regxp);
        return !isNull(match);
    }
    return (foreignAnswer == xpress);
};

// $.ccp=n && $.ccs=n
// $.=n

/**
 * @param String
 * @param Array | Object | null
 * @return Boolean
 */
const expresionResolvr = (rulestr, answer) =>
{
    if (isNil(answer))
    {
        return false;
    }
    const expressions = rulestr.split(/\s?\&{1,2}\s?/);
    const rules = map(expressions, (xpress) => xpress.split(/\s?={1,2}\s?/));
    const match = every(rules, (rule) =>
    {
        const path = trim(rule[0], '.').split('.');
        const wanted = rule[1];

        try
        {
            switch (path.length)
            {
                case 2:
                    return (wanted == answer[path[1]]);
                case 3:
                    return (wanted == answer[path[1]][path[2]]);
                case 4:
                    return (wanted == answer[path[1]][path[2]][path[3]]);
                case 5:
                    return (wanted == answer[path[1]][path[2]][path[3]][path[4]]);
                case 1:
                default: // ??
                    return (wanted == answer);
            }

        }
        catch(err)
        {
            return false;
        }
    });
    return match;
};

export { challengeTruthy, expresionResolvr }



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/helpers.js